import {
  ButtonPrimeReact,
  Dropzone,
  PrimeReactModal,
} from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { postImportarFactura } from "api/Factura.service"
import { STATUSCORRECT } from "common/components/ModalVerDocumento/constants"
import notification from "common/utils/notification"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import { IMPORTAR_FACTURAE } from "routes/RoutePaths"

function ImportarFacturasEModal() {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const [files, setFiles] = useState<File[]>([])

  const replaceHash = () => {
    history.replace({
      hash: "",
    })
  }
  const handleFileAccepted = async (files: File[]) => {
    setFiles(files)
  }

  const handleDeleteFile = async (fileToDelete: File) => {
    setFiles((prev) =>
      prev.filter((prevFile) => prevFile.name !== fileToDelete.name)
    )
  }

  const handleConfirm = async () => {
    try {
      const res = await postImportarFactura(files)
      if (res.status === STATUSCORRECT) {
        notification.success({
          body: `${t("importar.facturaExc.msgSucess")}`,
        })
        replaceHash()
      }
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Error: ${error.message}`)
      } else {
        throw new Error("Error: handleConfirm")
      }
    }
  }

  useEffect(() => {
    if (location.hash === IMPORTAR_FACTURAE) {
      setFiles([])
    }
  }, [location.hash])

  return (
    <PrimeReactModal
      pt={{
        root: {
          className:
            "tw-p-4 tw-rounded-md tw-bg-white tw-shadow-lg tw-w-full tw-max-w-5xl tw-max-h-vhcalc-100 tw-m-4",
        },
        mask: {
          className: "tw-bg-black/50",
        },
        header: {
          className: "tw-flex tw-justify-between tw-items-center tw-pb-2",
        },
        headerTitle: {
          className: "tw-text-2xl tw-font-medium tw-text-primary",
        },
        headerIcons: {
          className: "tw-flex tw-justify-end",
        },
        content: {
          className: "tw-flex tw-flex-col tw-gap-4 tw-overflow-auto tw-h-full",
        },
        closeButton: {
          className: "tw-text-erp-primary tw-text-xl",
        },
      }}
      header={`${t("importar.facturae.title")}`}
      onHide={replaceHash}
      visible={Boolean(location.hash === IMPORTAR_FACTURAE)}
      closeOnEscape
      closable
      footer={
        <div
          key='Continuar'
          className='tw-pb-1 tw-flex tw-flex-col sm:tw-flex-row sm:tw-gap-4 tw-justify-end tw-pt-3'
        >
          <ButtonPrimeReact
            type='reset'
            label={`${t("importar.facturae.cancelButton")}`}
            className='tw-w-full md:tw-w-fit tw-h-12 !tw-bg-simple-10 !tw-text-primary hover:!tw-text-primary-over !tw-border-none tw-items-center'
            onClick={() => {
              replaceHash()
            }}
          />
          <ButtonPrimeReact
            type='submit'
            label={`${t("importar.facturae.confirmButton")}`}
            className='tw-w-full md:tw-w-fit !tw-h-12 !tw-bg-secondary disabled:!tw-bg-primary-25 hover:!tw-bg-secondary-over disabled:!tw-cursor-not-allowed !tw-text-simple-10 !tw-border-none tw-items-center'
            onClick={() => handleConfirm()}
            disabled={!files?.length}
          />
        </div>
      }
    >
      {!files?.length ? (
        <div className='tw-w-full'>
          <Dropzone
            multiple
            maxFiles={100}
            accept={{
              "aplication/xml": [".xml"],
            }}
            onFileAccepted={handleFileAccepted}
          />
        </div>
      ) : (
        <div className='tw-flex tw-grid-cols-[repeat(auto-fill,_5rem)] sm:tw-grid tw-flex-wrap tw-gap-4 sm:tw-justify-center tw-p-2 tw-overflow-auto tw-max-h-vhcalc-300'>
          {files.map((file) => (
            <div
              key={file.name}
              className='tw-relative tw-flex tw-flex-row tw-items-center sm:tw-flex-col tw-w-full sm:tw-w-20 sm:tw-text-center tw-shrink-0 tw-gap-2 tw-px-2'
            >
              <FontAwesomeIcon
                icon={["fal", "file-xml"]}
                className='tw-text-primary tw-w-9 tw-h-9'
              />
              <span className='tw-text-xs tw-text-center tw-line-clamp-2 tw-break-all tw-w-16'>
                {file.name}
              </span>
              <span
                className='tw-absolute tw-top-0 tw-right-1 tw-flex tw-justify-center tw-items-center tw-p-1 tw-rounded-md tw-bg-danger-10 hover:tw-shadow-sm tw-cursor-pointer'
                onClick={() => handleDeleteFile(file)}
              >
                <FontAwesomeIcon
                  icon={["fal", "xmark"]}
                  className='tw-text-danger tw-w-2 tw-h-2 tw-cursor-pointer'
                />
              </span>
            </div>
          ))}
        </div>
      )}
    </PrimeReactModal>
  )
}

export default ImportarFacturasEModal
